import * as React from 'react';

const styles = require('./LoadingIcon.pcss');

interface IState {
    visible: boolean;
}

interface IProps {
    isLoading?: boolean;
}

export class LoadingIcon extends React.Component< IProps, IState>{
    
    constructor(props) {
        super(props);

    }

    render() {

        let { isLoading } = this.props;
        
        let visibility = this.props.isLoading == true ? styles.show : styles.hide,
            internalClasses = `${styles.loadingIcon} ${visibility}`
        

        return (


            <div className={internalClasses}>

                <div className={styles.loader}></div>
                <div className={styles.loadingBodyText}>
                    <p>Loading</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/Filtersidebar/LoadingIcon/LoadingIcon.tsx